import { render } from "./TheDatenschutzView.vue?vue&type=template&id=27d71c43&scoped=true"
import script from "./TheDatenschutzView.vue?vue&type=script&lang=js"
export * from "./TheDatenschutzView.vue?vue&type=script&lang=js"

import "./TheDatenschutzView.vue?vue&type=style&index=0&id=27d71c43&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27d71c43"]])

export default __exports__